import { CategoryVector } from "@imi-ernd-be/hyselect-engine";
import { withDelete } from "../helpers/withDelete";
import { toArray } from "../vector";
import { ProductCategory } from "./types";

export function buildProductCategories(
  categories: CategoryVector,
): ProductCategory[] {
  return toArray(categories).map((category) =>
    withDelete(category, {
      deleted: category.deleted,
      id: category.id,
      name: category.name,
      subCategories: buildProductCategories(category.getSubCategoryList()),
    }),
  );
}
